import { styled } from "@mui/material"

export const Card = styled("section")({
  borderRadius: "16px",
  height: "auto",
  overflow: "hidden",
  // border: "1px solid black",
  backgroundColor: "#fafafa",
  // backgroundColor: "red",
  boxShadow: "2px 2px 5px 4px rgba(0, 0, 0, 0.05)",
})

export const CardHeader = styled("header")({
  width: "100%",
  padding: "0",
})

export const CardContent = styled("article")({
  padding: "20px 40px 24px 40px",
  display: "grid",
  rowGap: "20px"
})
